module.exports = __webpack_public_path__ + "img/ban_6.e5603dfe.png";